import type { ReactNode } from 'react'
import { AppLayout } from '@/components/layout/AppLayout'
import { PageContainer } from '@/components/layout/PageContainer'
import { AdminSidebar } from './AdminSidebar'
import type { AdminTab } from '@/types/admin'

interface AdminShellProps {
  active: AdminTab
  onSelect: (key: AdminTab) => void
  children: ReactNode
}

/** The panel's frame: title, section sidebar and the section itself. */
export function AdminShell({ active, onSelect, children }: AdminShellProps) {
  return (
    <AppLayout>
      <PageContainer className="py-12 sm:py-16">
        <h1 className="mb-8 font-display text-3xl leading-tight text-heading sm:text-4xl lg:mb-10">
          Admin
        </h1>

        <div className="flex flex-col gap-8 lg:grid lg:grid-cols-[13rem_minmax(0,1fr)] lg:gap-12">
          <AdminSidebar active={active} onSelect={onSelect} />

          <section aria-labelledby="admin-section-title" className="min-w-0">
            {children}
          </section>
        </div>
      </PageContainer>
    </AppLayout>
  )
}
